import React from 'react'

const Cp_str = () => {
    return (
        <div className='container'>
            <h1>C++ Strings</h1>
            <p>String is a collection of characters. There are two types of strings commonly used in C++ programming language:</p>
            <ul>
	<li>Strings that are objects of string class (The Standard C++ Library string class)</li>
	<li>C-strings (C-style Strings)</li>
</ul>
<h2>C -strings</h2>
<p>In C programming, the collection of characters is stored in the form of arrays.&nbsp;This is also supported
     in C++ programming. Hence it's called C-strings.</p>
     <p>C-strings are arrays of type <code>char</code> terminated with null character, that is, <code>\0</code> (ASCII value of null character is 0).</p>
     <h3>How to define a C-string?</h3>
     <pre className='container'>char str[] = "C++";</pre>
     <p>In the above code, <code>str</code> is a string and it holds 4 characters.</p>
     <p>Although, "<code>C++</code>" has 3 character, the null character <code>\0</code>&nbsp;is added to the end of the string automatically.</p>
     <h3>Alternative ways of defining a string</h3>
     <pre class="containers">
  <code class='keywords'>char</code> str[4] = "C++"; <br/>
      <br/>
 <code class='keywords'> char </code>str[] =&#123;'C','+','+','\0'&#125;; <br/>
   <br/>
  <code class='keywords'>char</code> str[4] =&#123;'C','+','+','\0'&#125; <br/>;</pre>
  <p>Like arrays, it is not necessary to use all the space allocated for the string. For example:</p>
  <pre>char str[100] = "C++";</pre>
  
     <h3>Example 1: C++ String to read a word</h3>
     <p><b>C++ program to display a string entered by user.</b></p>
     <div class="containers"> <br/>
  <code class="cpp hljs"><span class="meta">#<span class="keywords">include</span> <span class="library">&lt;iostream&gt;</span></span> <br/>
  <span class="keywords">using</span> <span class="keywords">namespace</span> <span class="library">std</span>; <br/>
   <br/>
  <span class="function"><span class="keywords">int</span> <span class="title">main</span><span class="params">()</span> <br/>
  </span>&#123; <br/>
      <span class="keywords">char</span> str[<span class="number">100</span>]; <br/>
   <br/>
      <span class="library">cout</span> &lt;&lt; <span class="plain">"Enter a plain: "</span>; <br/>
      <span class="library">cin</span> &gt;&gt; str; <br/>
      <span class="library">cout</span> &lt;&lt; <span class="plain">"You entered: "</span> &lt;&lt; str &lt;&lt; <span class="library">endl</span>; <br/>
   <br/>
      <span class="library">cout</span> &lt;&lt; <span class="plain">"\nEnter another plain: "</span>; <br/>
      <span class="library">cin</span> &gt;&gt; str; <br/>
      <span class="library">cout</span> &lt;&lt; <span class="plain">"You entered: "</span>&lt;&lt;str&lt;&lt;<span class="library">endl</span>; <br/>
   <br/>
      <span class="keywords">return</span> <span class="number">0</span>; <br/>
  &#125;</code></div> 
  <p><b>Output</b></p>
  <div className='output'>
  <pre><samp>Enter a string: C++ <br/>
  You entered: C++ <br/>
   <br/>
  Enter another string: Programming is fun. <br/>
  You entered: Programming</samp> <br/>
  </pre> <br/>
  </div>
  <p>Notice that, in the second example only "Programming" is displayed instead of "Programming is fun".</p>
  <p>This is because the extraction operator &gt;&gt; works as scanf() in C and considers a space " " has a terminating character.</p>
  <h2>Example 2: C++ String to read a line of text</h2>
  <div class="containers"><span class="meta">#<span class="keywords">include</span> <span class="string">&lt;iostream&gt;</span></span> <br/>
  <span class="keywords">using</span> <span class="keywords">namespace</span> <span class="library">std</span>; <br/>
   <br/>
  <span class="function"><span class="keywords">int</span> <span class="title">main</span><span class="plain">()</span> <br/>
  </span>&#123; <br/>
      <span class="keywords">char</span> str[<span class="number">100</span>]; <br/>
      <span class="library">cout</span> &lt;&lt; <span class="string">"Enter a string: "</span>; <br/>
      <span class="library">cin</span>.get(str, <span class="number">100</span>); <br/>
   <br/>
      <span class="library">cout</span> &lt;&lt; <span class="string">"You entered: "</span> &lt;&lt; str &lt;&lt; <span class="library">endl</span>; <br/>
      <span class="keywords">return</span> <span class="number">0</span>; <br/>
  &#125;</div>
  <p><b>Output</b></p>
  <div className='output'>
  <pre><samp>Enter a string: Programming is fun. <br />
You entered: Programming is fun. <br />
</samp></pre>
  </div>
  <p>To read the text containing blank space, <code>cin.get</code> function can be used. This function takes two arguments.</p>
  <p>First argument is the name of the string (address of first element of string) and second argument is the maximum size of the array.</p>
  <p>In the above program, <var>str</var> is the name of the string and <code>100</code> is the maximum size of the array.</p>
  <h2>string Object</h2>
  <p>In C++, you can also create a string object for holding strings.</p>
  <p>Unlike using char arrays, string objects has no fixed length, and can be extended as per your requirement.</p>
  <h3>Example 3: C++ string using string data type</h3>
  <div class="containers"><span class="library">#<span class="library">include</span> <span class="library">&lt;iostream&gt;</span></span>
  <span class="keywords">using</span> <span class="keywords">namespace</span> <span class="library">std</span>;
  
  <span class="function"><span class="keywords">int</span> <span class="title">main</span><span class="params">()</span>
  </span>&#123;
      <span class="comment">// Declaring a string object</span>
      <span class="library">string</span> str;
      <span class="library">cout</span> &lt;&lt; <span class="plain">"Enter a string: "</span>;
      getline(<span class="library">cin</span>, str);
  
      <span class="library">cout</span> &lt;&lt; <span class="plain">"You entered: "</span> &lt;&lt; str &lt;&lt; <span class="library">endl</span>;
      <span class="keywords">return</span> <span class="number">0</span>;
  &#125;</div>
  <p><b>Output</b></p>
  <pre className='output'><samp>Enter a string: Programming is fun. <br />
You entered: Programming is fun. <br />
</samp></pre>
<p>In this program, a string <var>str</var> is declared. Then the string is asked from the user.</p>
<p>Instead of using <code>cin&gt;&gt;</code> or <code>cin.get()</code> function, you can get the entered line of text using <code>getline()</code>.</p>
<p><code>getline()</code> function takes the input stream as the first parameter which is <code>cin</code> and <code>str</code> as the location of the line to be stored.</p>

        </div>
    )
}

export default Cp_str
